import { useState } from "react";
import Modal from "../shared/Modal";
import { useSelector, useDispatch } from "react-redux";
import { selectUser } from "../../redux/features/appData/";
import "./ModalSnippetDiscardChanges.css";
import { Button } from "../../ds2/components";

type ModalSnippetDiscardChangesProps = {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

const ModalSnippetDiscardChanges = ({
  isOpen,
  onClose,
  onContinue,
}: ModalSnippetDiscardChangesProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      <Modal
        isOpen={isOpen}
        style={null}
        onClose={onClose}
        canClose={false}
        allowClickout={true}>
        <div id="modal-snippet-discard">
          <div className="modal-snippet-discard-title">
            You Have Unsaved Changes
          </div>

          <div className="modal-snippet-discard-content">
            You have unsaved changes to this snippet. Continuing will discard
            them?
          </div>

          <div className="edit-tag-name-footer">
            <div className="edit-tag-name-buttons">
              <Button 
                onClick={onClose}
                variant="secondary"
                >
                Cancel
              </Button>
              <Button 
                onClick={onContinue} 
                
              >
                Continue
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ModalSnippetDiscardChanges;

